import { Accordion, CollapseItem } from "@/components";
import useChatStore from "@/store/chatStore";
import React, { useMemo } from "react";
import FileList from "./MemberList/FileList";
import MemberList from "./MemberList/MemberList";
import { SidebarType } from "./RightSection";
import { cn } from "@/utils";

interface Props {
  roomId: number;
  activeSidebar?: SidebarType | null;
  hiddenSideBar?: () => void;
}

const SideBarMini = ({
  children,
  visible,
}: {
  children: React.ReactNode;
  visible: boolean;
}) => {
  return (
    <div
      className={cn(
        "block xl:hidden",
        "absolute bg-white w-full h-full transition-opacity duration-300",
        visible ? "z-10 opacity-100" : "-z-10 opacity-0 pointer-events-none"
      )}
    >
      {children}
    </div>
  );
};

const MemberAndFileSection: React.FC<Props> = ({
  roomId,
  activeSidebar = null,
  hiddenSideBar,
}) => {
  const { memberNumber } = useChatStore();

  const accordionItems = useMemo(() => {
    return [
      {
        label: `ルーム（${memberNumber}）`,
        key: "members",
        children: [
          {
            key: "member-list",
            label: roomId ? <MemberList key={roomId} roomId={roomId} /> : null,
          },
        ],
      },
      {
        label: "添付ファイル",
        key: "attachments",
        children: [
          {
            key: "file-list",
            label: roomId ? <FileList roomId={roomId} /> : null,
          },
        ],
        triggerClassName: "border-t",
      },
    ] as CollapseItem[];
  }, [roomId, memberNumber]);

  return (
    <>
      <section className="hidden xl:block w-[220px] 2xl:w-[240px] h-full overflow-y-auto border">
        <Accordion
          items={accordionItems}
          triggerClassName="p-3 text-xs text-grey-600 font-bold cursor-pointer"
          defaultValue={["members", "attachments"]}
          childItemClassName="cursor-[unset]"
        />
      </section>

      <section
        className={cn(
          "block xl:hidden",
          "bg-white absolute left-0 top-[1px] z-10 w-full h-full overflow-y-auto transform transition-transform duration-500 translate-x-full ease-in-out",
          !!activeSidebar ? "translate-x-0" : "translate-x-full"
        )}
      >
        <SideBarMini visible={activeSidebar == SidebarType.FILE}>
          <FileList roomId={roomId} hiddenSideBar={hiddenSideBar} />
        </SideBarMini>

        <SideBarMini visible={activeSidebar == SidebarType.USER}>
          <MemberList
            key={roomId}
            roomId={roomId}
            hiddenSideBar={hiddenSideBar}
          />
        </SideBarMini>
      </section>
    </>
  );
};

export default MemberAndFileSection;
